import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { connect } from 'react-redux';
import { fetchParentCommittees } from '../../../../../../Redux/Actions/Admin/ManageCommitteeAction';
import axios from 'axios'
import '../ManageBatches.scss';
import swal from 'sweetalert';
import ToggleStatus from './ToggleStatus';
import BatchDelete from './BatchDelete';

class BatchDetails extends Component {
	constructor(props) {
		super(props);
		let d = {...this.props.dataItem}
		if (this.props.dataItem.BatchJobId) {
			d.BatchStatus = { id: d.BatchStatusId, name: d.BatchStatus };
			d.BatchType = { id: d.BatchTypeId, name: d.BatchType };
			d.BatchDate = new Date(this.props.dataItem.BatchDate);
		}
		else {
			d.BatchDate = new Date();
			d.BatchName = '';
		}
		this.state = {
            batchInEdit: d,
			batchStatuses: this.props.batchStatuses || [],
			batchTypes: this.props.batchTypes || []
		};
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.batchStatuses !== this.props.batchStatuses) {
            if (this.state.batchInEdit.BatchJobId) {
                this.setState({
                    batchStatuses: this.props.batchStatuses
                })
            } else {
                var edit = this.state.batchInEdit;
                edit.BatchStatus = this.props.batchStatuses.filter((item) => {
                    if (item.name === "Open") {
                        return item;
                    }
                })[0];
                this.setState({
                    batchStatuses: this.props.batchStatuses,
                    batchInEdit: edit
                })
            }
		}

		if (prevProps.batchTypes !== this.props.batchTypes) {
			var edit = this.state.batchInEdit;

			this.setState({
				batchTypes: this.props.batchTypes,
				batchInEdit: edit
			})
		}
    }

	handleStatusChange = (event) => {
		let b = { ...this.state.batchInEdit }
		let v = event.target.value;
		b.BatchStatus = { id: v.id, name: v.name };
		this.setState({
			batchInEdit: b
		});
	}

	handleBatchTypeChange = (event) => {
		let b = { ...this.state.batchInEdit }
		let v = event.target.value;
		b.BatchType = { id: v.id, name: v.name };
		this.setState({
			batchInEdit: b
		});
	}

	handleDateChange = (date) => {
		let b = { ...this.state.batchInEdit }
		b.BatchDate = date.value;
		this.setState({
			batchInEdit: b
		});
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.save(this.state.batchInEdit);
	}

	onDialogInputChange = (event) => {
		let b = { ...this.state.batchInEdit };
		b[event.target.name] = event.target.value;

		this.setState({
			batchInEdit: b
		});
	}

	render() {
		return (
			<div className="batchForm">
				{!this.state.batchInEdit.BatchJobId ?
					<h2 className="edit-committe-title">Add New Batch</h2> :
					<h2 className="edit-committe-title">Edit Batch</h2>}
                <form className="user-form adjusting" onSubmit={this.handleSubmit}>
                    <div className="row">
						<div className="col-md-4">
							<label htmlFor="BatchName">Batch Name</label>
							<Input
								required={true}
								type="text"
								name="BatchName"
								id="BatchName"
								value={this.state.batchInEdit.BatchName}
								onChange={this.onDialogInputChange}
							/>
						</div>		
						<div className="col-lg-4">
							<label htmlFor="batchType">Batch Type</label>
							{this.state.batchTypes.length > 0 ?
								<DropDownList
									data={this.props.batchTypes}
									onChange={this.handleBatchTypeChange}
									value={this.state.batchInEdit.BatchType}
									textField="name"
									dataItemKey="id"
									allowCustom={true}
									disabled={this.state.batchInEdit.BatchJobId ? true : false}
									name="BatchType"
									id="BatchType"
									required={true}
								/> : ""}
						</div>
						<div className="col-lg-4">
							<label htmlFor="BatchDate">Batch Date</label>
							<DatePicker
								required={true}
								disableClock={true}
								value={this.state.batchInEdit.BatchDate}
								onChange={this.handleDateChange}
								id="BatchDate"
								name="BatchDate"
							/>
						</div>
					</div>					
					<div className="row">
						{this.state.batchInEdit.BatchJobId ?
						<div className="col-md-4">
							<label htmlFor="BatchNumber">Batch Number</label>
							<Input
								type="text"
								name="BatchNumber"
								id="BatchNumber"
								value={this.state.batchInEdit.BatchJobId}
								disabled={true}
							/>
						</div>
							: ""}
						{this.state.batchInEdit.BatchJobId ?
							<div className="col-md-4">
								<label htmlFor="BatchSource">Batch Source</label>
								<Input
									type="text"
									name="BatchSource"
									id="BatchSource"
									value={this.state.batchInEdit.BatchSource}
									disabled={true}
								/>
							</div>
							: ""}
						<div className="col-lg-4" style={{display: "inherit", margin: "39px 0 0 0"}}>
							<ToggleStatus
								toggleStatus={this.props.toggleStatus}
								dataItem={this.state.batchInEdit}
								batchStatuses={this.props.batchStatuses}
							/>
							<BatchDelete
								deleteBatch={this.props.deleteBatch}
								dataItem={this.state.batchInEdit}
							/>
						</div> 
					</div>
					{this.state.batchInEdit.BatchJobId ?
					<div className="row">
						<div className="col-lg-4"></div>
							<div className="col-lg-4"></div>	
							<div className="col-lg-4"></div>
						</div>
						:""}
					<div className="footer col-md-12 edit-cmt-btns">
						<div className="form-group">
							<button className="admin-k-button" onClick={this.props.cancel}>
								<i className="fas fa-times"></i>
								<span>CANCEL</span>
							</button>
							{!this.state.batchInEdit.bacthId ? (
								<button type="submit" className="admin-k-button">
									<i className="fas fa-save"></i>
									<span>SAVE</span>
								</button>
							) : (
									<button type="submit" className="admin-k-button update-btn">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
						</div>
					</div>
				</form>
			</div>			
		);
	}
}

export default BatchDetails;
